import React from 'react';
import ControlToggleGroup from './ControlToggleGroup';

export const FORMAT_TOGGLE_OPTIONS = [
  {
    value: 'M',
    tooltip: 'Format Values in Millions',
    sublabel: '$M',
  },
  {
    value: 'B',
    tooltip: 'Format Values in Billions',
    sublabel: '$B',
  },
];

function ControlFormatToggle({
  context = 'filterBar',
  value,
  onChange,
  label = 'Format Values',
  labelWidth = 50,
  buttonWidth = 30,
  ariaLabel = 'Value format',
}) {
  return (
    <ControlToggleGroup
      context={context}
      value={value}
      onChange={onChange}
      options={FORMAT_TOGGLE_OPTIONS}
      label={label}
      labelWidth={labelWidth}
      buttonWidth={buttonWidth}
      mode="text"
      ariaLabel={ariaLabel}
    />
  );
}

export default ControlFormatToggle;
